<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="handleCancelButtonClick">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>
        Case {{ editedCase.title }}
        <a :href="resolveCaseServicePageUrl()"
           target="_blank"
           class="caseServicesLink">
          <v-icon @click.stop=''>fa-file-invoice-dollar</v-icon>
        </a>
      </v-toolbar-title>
      <v-spacer/>
    </v-toolbar>
    <v-card-text>
      <div>
        <table>
          <tr>
            <td class="case-param-name"><strong>Case in DP</strong></td>
            <td v-if="!editedCase.dpId">{{ editedCase.title | NoEmpty}}</td>
            <td v-else><a :href="buildDPCaseUrl(editedCase.dpId)" target="_blank" @click.stop=''>{{ editedCase.title}}</a></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Patient cases</strong></td>
            <td>
              <v-data-table :headers="patientCasesHeaders"
                            :loading="patientCasesProgress"
                            :items="patientCases"
                            no-data-text="No another patient cases"
                            hide-actions>
                <template slot="items" slot-scope="props">
                  <tr>
                    <td v-if="props.item.dpCaseLink === null">{{ props.item.title }}</td>
                    <td v-else><a :href="props.item.dpCaseLink" target="_blank" @click.stop=''>{{ props.item.title}}</a></td>
                    <td>{{ props.item.creationDatetime | DateWithMinutes | NoEmpty}}</td>
                    <td>{{ props.item.clientTitle }}</td>
                    <td v-bind:class="{fuzzyValue: props.item.patientNameFuzzy}">{{ props.item.patientName }}</td>
                    <td v-bind:class="{fuzzyValue: props.item.patientBirthdayFuzzy}">{{ props.item.birthday }}</td>
                    <td>{{ props.item.match }}</td>
                  </tr>
                </template>
              </v-data-table>
            </td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Client</strong></td><td><span>{{ clientTitle | NoEmpty}}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Case creation date</strong></td><td><span>{{ editedCase.creationDatetime | DateWithMinutes | NoEmpty}}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Period Execution</strong></td><td><span>{{ editedCase.periodExecution }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Materials receiving date</strong></td><td><span>{{ editedCase.receiptMaterialsDatetime | DateWithMinutes | NoEmpty}}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>External label</strong></td>
            <td>
              <text-input-with-controls
                controlWidth="400px"
                color="gray"
                solo
                context="externalLabel"
                :canEdit="canEditFields"
                :saveHandler="caseSimpleFieldSaveHandler"
                :value="editedCase.externalLabel"/>
            </td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Materials returned at</strong></td><td>
            <text-input-with-controls
              controlWidth="400px"
              color="gray"
              solo
              placeholder="Format YYYY-MM-DD"
              context="materialsReturnedDate"
              :canEdit="canEditFields"
              :saveHandler="caseSimpleFieldSaveHandler"
              :value="editedCase.materialsReturnedDate"/></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Patient name</strong></td><td>
            <text-input-with-controls
              controlWidth="400px"
              solo
              color="gray"
              context="patientName"
              :canEdit="canEditFields"
              :saveHandler="caseSimpleFieldSaveHandler"
              :value="editedCase.patientName"/></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Patient birthday</strong></td><td>
            <text-input-with-controls
              controlWidth="400px"
              solo
              color="gray"
              context="patientBirthday"
              :canEdit="canEditFields"
              :saveHandler="caseSimpleFieldSaveHandler"
              :value="editedCase.patientBirthday"/></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Patient phone</strong></td><td>
            <text-input-with-controls
              controlWidth="400px"
              solo
              color="gray"
              context="patientPhone"
              :canEdit="canEditFields"
              :saveHandler="caseSimpleFieldSaveHandler"

              :value="editedCase.patientPhone"/></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Patient address</strong></td><td>
            <text-input-with-controls
              controlWidth="400px"
              solo
              color="gray"
              context="patientAddress"
              :canEdit="canEditFields"
              :saveHandler="caseSimpleFieldSaveHandler"
              :value="editedCase.patientAddress"/></td>
          </tr>

          <tr>
            <td class="case-param-name"><strong>Patient registration place</strong></td>
            <td>
              <v-autocomplete
                :items="availableAreas"
                :disabled="!canEditFields"
                v-model="editedCase.registrationPlace"
                context="registrationPlace"
                item-value="id"
                item-text="name"
                no-data-text="No specialists"
                style="width: 400px; max-width: 400px"
                label="Please, select area"
                persistent-hint
                clearable
                @change="handleCaseAreaChange"
              />
            </td>
          </tr>
          <tr>
           <td class="case-param-name">
              <strong>SNILS</strong>
            </td>
            <td>
              <text-input-with-controls
                controlWidth="400px"
                solo
                color="gray"
                context="snils"
                :canEdit="canEditFields"
                :saveHandler="caseSimpleSnilsFieldSaveHandler"
                :value="editedCase.snils"/>
              </td>
          </tr>
          <tr>
            <td class="case-param-name">
              <strong>OMI policy number</strong>
            </td>
            <td>
              <text-input-with-controls
                controlWidth="400px"
                solo
                color="gray"
                context="omiPolicyNumber"
                :canEdit="canEditFields"
                :saveHandler="caseSimpleOMIFieldSaveHandler"
                :value="editedCase.omiPolicyNumber"/>
              </td>
          </tr>
          <tr>

          <tr>
            <td class="case-param-name"><strong>Patient email</strong></td><td>
            <text-input-with-controls
              controlWidth="400px"
              solo
              color="gray"
              context="patientEmail"
              :canEdit="canEditFields"
              :saveHandler="caseSimpleFieldSaveHandler"
              :value="editedCase.patientEmail"/></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Incoming diagnosis</strong></td><td>
            <text-area-with-controls
              controlWidth="400px"
              :saveHandler="caseSimpleFieldSaveHandler"
              context="incomingDiagnosis"
              :canEdit="canEditFields"
              :value="editedCase.incomingDiagnosis"
              solo
              color="gray"
              auto-grow
            ></text-area-with-controls></td>
          </tr>

          <tr>
            <td class="case-param-name">
              <strong>Incoming diagnosis ICD10</strong>
            </td>
            <td>
              <text-input-with-controls
                controlWidth="400px"
                :saveHandler="caseSimpleFieldSaveHandler"
                context="icd10"
                :canEdit="canEditFields"
                :value="editedCase.icd10"
                solo
                color="gray"
              ></text-input-with-controls>
            </td>
          </tr>
          <tr>
            <td class="case-param-name">
              <strong>Material sampling date</strong>
            </td>
            <td>
              <text-input-with-controls
                controlWidth="400px"
                :saveHandler="caseMaterialSamplingFieldSaveHandler"
                context="materialSampling"
                :canEdit="canEditFields"
                v-model="material_sampling"
                solo
                color="gray"
                auto-grow
                type="datetime-local"
              ></text-input-with-controls>
            </td>
          </tr>

          <tr>
            <td class="case-param-name"><strong>Outgoing diagnosis</strong></td><td><span>{{ editedCase.outgoingDiagnosis | NoEmpty }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Incoming Raw Material</strong></td><td><span>{{ getItemDataByPath(editedCase, 'incomingRawMaterials') }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Slides created from incoming histoblocks</strong></td><td><span>{{ getItemDataByPath(editedCase, 'slidesCreatedFromIncomingHistoblocks') }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Incoming histoblocks registered</strong></td><td><span>{{ getItemDataByPath(editedCase, 'incomingHistoblocksRegistered') }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Incoming Slides Scanned</strong></td><td><span>{{ getItemDataByPath(editedCase, 'incomingSlidesScanned') }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Incoming Slides Created</strong></td><td><span>{{ getItemDataByPath(editedCase, 'incomingSlidesCreated') }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>New Histoblock Created</strong></td><td><span>{{ getItemDataByPath(editedCase, 'newHistoblockCreated') }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>New IHC Slides Created</strong></td><td><span>{{ getItemDataByPath(editedCase, 'ihcSlidesCreated') }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>New HC Slides Created</strong></td><td><span>{{ getItemDataByPath(editedCase, 'hcSlidesCreated') }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>New H&E Slides Created</strong></td><td><span>{{ getItemDataByPath(editedCase, 'heSlidesCreated') }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>New IHC Slides Scanned</strong></td><td><span>{{ getItemDataByPath(editedCase, 'ihcSlidesScanned') }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>New HC Slides Scanned</strong></td><td><span>{{ getItemDataByPath(editedCase, 'hcSlidesScanned') }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>New H&E Slides Scanned</strong></td><td><span>{{ getItemDataByPath(editedCase, 'heSlidesScanned') }}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Price</strong></td><td><span>{{ editedCase.price | currency}}</span></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Paid amount</strong></td><td>
              <text-input-with-controls
                controlWidth="400px"
                solo
                color="gray"
                :canEdit="true"
                :outputFormatters="paidAmountFormatters"
                :saveHandler="paidAmountSaveHandler"
                :value="editedCase.paymentAmount"/></td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Comment</strong></td>
            <td>
              <text-area-with-controls
                controlWidth="400px"
                :saveHandler="commentSaveHandler"
                :canEdit="true"
                :value="editedCase.comment"
                solo
                color="gray"
                auto-grow
              ></text-area-with-controls>
            </td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Client</strong></td>
            <td>
              <change-case-client-form
              :case-id="editedCase.id"
              :current-client-id="editedCase.clientId"
              :editable="canEditFields"
              @caseUpdated="handleCaseUpdated"/>
            </td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Specialist</strong></td>
            <td>
              <v-autocomplete
                :items="availableSpecialists"
                :disabled="!canEditFields"
                v-model="editedCase.clientSpecialistId"
                item-value="id"
                item-text="name"
                no-data-text="No specialists"
                style="width: 400px; max-width: 400px"
                label="Please, select specialist"
                persistent-hint
                clearable
                @change="handleCaseSpecialistChange"
              />
            </td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Request data</strong></td>
            <td>
              <v-btn color="primary lighten-2" :disabled="!clientHasEmail" @click="handleCreateRequestClick">Create request</v-btn>
            </td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Hold control</strong></td>
            <td>
              <div v-if="holdButtonVisible">
                <span class="mr-2">Is not on hold</span>
                <v-btn color="primary lighten-2"
                       :disabled="holdInProgress"
                       :loading="holdInProgress"
                       @click="handleHoldClick">
                  Hold
                </v-btn>
              </div>
              <div v-else>-</div>
              <div v-if="editedCase.onHold">
                <span class="mr-2">Is on hold</span>
                <v-btn color="primary lighten-2"
                       :disabled="unholdInProgress"
                       :loading="unholdInProgress"
                       @click="handleRemoveHoldClick">
                  Remove hold
                </v-btn>
              </div>
            </td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Hold history</strong></td>
            <td>
              <table class="v-table table-striped" v-if="holdHistoryVisible">
                <thead>
                  <tr>
                    <th>Start</th>
                    <th>Finish</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="hold in editedCase.holdHistory" :key="hold.start + '-' + hold.reason">
                    <td>{{ hold.start | DateWithMinutes | NoEmpty }}</td>
                    <td>{{ hold.finish | DateWithMinutes | NoEmpty }}</td>
                    <td>{{ hold.reason }}</td>
                  </tr>
                </tbody>
              </table>
              <span v-else>
                No history
              </span>
            </td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Estimated completion datetime correction</strong></td>
            <td>
              <case-estimation-correction-form
                v-if="correctButtonVisible"
                :case-id="editedCase.id"
              @caseFieldUpdated="emitCaseFieldUpdated"/>
              <div v-else>-</div>
            </td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Estimated completion datetime correction history</strong></td>
            <td>
              <table class="v-table table-striped" v-if="ecdcHistoryVisible">
                <thead>
                <tr>
                  <th>Date</th>
                  <th>Hours</th>
                  <th>Reason</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="ecdcItem in editedCase.ecdcHistory" :key="ecdcItem.correctionDatetime + '-' + ecdcItem.reason">
                  <td>{{ ecdcItem.correctionDatetime | DateWithMinutes | NoEmpty }}</td>
                  <td>{{ ecdcItem.hours }}</td>
                  <td>{{ ecdcItem.reason }}</td>
                </tr>
                </tbody>
              </table>
              <span v-else>
                No history
              </span>
            </td>
          </tr>
          <tr>
            <td class="case-param-name"><strong>Update case in dp</strong></td>
            <td v-if="editedCase.dpId">
              <v-btn color="primary lighten-2"
                       :disabled="updateCaseInDPInProgress"
                       :loading="updateCaseInDPInProgress"
                       @click="handleUpdateCaseInDpButtonClick">
              Update
              </v-btn>
            </td>
            <td v-else>
              -
            </td>
          </tr>
        </table>
      </div>
      <v-flex d-block xs4 class="mt-5 mb-0" v-if="canEditFields">
        <v-text-field
          v-model="filters.titleOrCode"
          label="Search by title / code"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex d-block xs12>
        <case-services :case="editedCase"
                       :availableCaseServices="availableClientServices"
                       :servicesById="servicesById"
                       :caseServices="editedCase.services"
                       :filters="filters"
                       @removedServiceFromCase="handleRemoveServiceFromCase"
                       @addedServiceToCase="handleAddServiceFromCase"
                       @updatedCaseService="handleUpdateCaseService"
                       @casePriceUpdated="handleUpdateCasePrice"
                       @requestedQuantityChanged="handleRequestedQuantityChanged"
                       @executedQuantityChanged="handleExecutedQuantityChanged"
                       v-if="canEditFields"></case-services>
      </v-flex>
      <v-layout row justify-center v-if="holdConfirmationWindowVisible">
        <v-dialog v-model="holdConfirmationWindowVisible" persistent max-width="600">
          <v-card>
            <v-card-title class="headline">Hold confirmation</v-card-title>

            <v-card-text>
              <v-text-field v-model="holdReason"
                            label="Reason"
                            placeholder="Please, enter hold reason"
                            :rules="reasonRules"
                            ref="holdReasonInput"
              ></v-text-field>

            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="primary darken-1"
                flat="flat"
                @click="handleHoldButtonClick"
              >
                Hold
              </v-btn>

              <v-btn
                color="gray darken-1"
                flat="flat"
                @click="handleHoldCancelButtonClick"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
       <v-layout row justify-center v-if="createRequestConfirmationWindowVisible">
        <v-dialog v-model="createRequestConfirmationWindowVisible" persistent max-width="600">
          <v-card>
            <v-card-title class="headline">Request data</v-card-title>

            <v-card-text>
              <p class="title-request">Clinic:</p>
              <v-checkbox hide-details v-model="createRequestSelectedEmails" :label="clientTitle + ' (' + clientEmails + ')'" :value="clientEmails"></v-checkbox>

              <div v-if="clientAdministrators.length > 0">
                <p class="title-request">Administrators:</p>
                <v-checkbox hide-details v-for="item in clientAdministrators" :key="item.id" v-model="createRequestSelectedEmails" :label="item.name + ' (' + item.email + ')'" :value="item.email"></v-checkbox>
              </div>

              <div v-if="clientSpecialists.length > 0">
                <p class="title-request">Specialists:</p>
                <v-checkbox hide-details v-for="item in clientSpecialists" :key="item.id" v-model="createRequestSelectedEmails" :label="item.name + ' (' + item.email + ')'" :value="item.email" @change="changeRequestSpecialist"></v-checkbox>
              </div>

              <p class="title-request">Template:</p>
              <v-radio-group hide-details v-model="createRequestTemplate">
                <v-radio label="Clinical Data" value="new_clinican_request"></v-radio>
                <v-radio label="New Service" value="new_service_request"></v-radio>
                <v-radio label="Empty Request" value="empty_request"></v-radio>
                <v-radio label="Delay Notify" value="delay_notify"></v-radio>
              </v-radio-group>
              <v-text-field v-model="createRequestReason"
                            label="Fill your request"
                            placeholder="Please, enter your request"
                            style="margin-top:40px"
              ></v-text-field>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" flat="flat" @click="sendCreatedRequest">
                Send
              </v-btn>
              <v-btn color="gray darken-1" flat="flat" @click="resetCreatedRequest">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import NoEmpty from '../Filters/NoEmpty.js'
import DateWithMinutes from '../Filters/DateWithMinutes.js'
import CaseServices from './CaseServices'
import TextInputWithControls from '../Ui/TextInputWithControls'
import TextAreaWithControls from '../Ui/TextAreaWithControls'
import _ from 'lodash'
import api from '../../api'
import {isNumeric} from '../../helpers/types'
import {extractErrorToArray} from '../../helpers/api'
import {showApiError} from '../../helpers/notification.js'
import {notificationService} from '../../application'
import ChangeCaseClientForm from './ChangeCaseClientForm'
import CaseEstimationCorrectionForm from './CaseEstimationCorrectionForm'

export default {
  name: 'case-details',
  filters: {
    NoEmpty,
    DateWithMinutes
  },
  components: {
    CaseServices,
    TextInputWithControls,
    TextAreaWithControls,
    ChangeCaseClientForm,
    CaseEstimationCorrectionForm
  },
  props: {
    clientsById: {
      type: Object
    },
    servicesById: {
      type: Object
    },
    editedCase: {
      type: Object
    },
    availableClientServices: {
      type: Array
    }
  },
  data() {
    return {
      patientCasesProgress: false,
      patientCasesLoaded: false,
      patientCasesRaw: null,
      paidAmountFormatters: [this.$options.filters.currency],
      editMode: false,
      changeClientId: null,
      holdConfirmationWindowVisible: false,
      holdReason: null,
      unholdInProgress: false,
      holdInProgress: false,
      updateCaseInDPInProgress: false,
      createRequestConfirmationWindowVisible: false,
      createRequestSelectedEmails: [],
      createRequestReason: '',
      createRequestTemplate: '',
      availableAreas: [{id: 'CITY', name: 'CITY'}, {id: 'COUNTRY', name: 'COUNTRY'}],
      filters: {
        titleOrCode: ''
      },
      reasonRules: [
        v => !!v || 'Enter hold reason',
        v => (v && v.length <= 1000) || 'The length of the reason should be no more than 1000 characters'
      ],
      patientCasesHeaders: [
        {
          text: 'Title',
          align: 'left',
          sortable: false
        },
        {
          text: 'Creation datetime',
          align: 'left',
          sortable: false
        },
        {
          text: 'Client',
          align: 'left',
          sortable: false
        },
        {
          text: 'Patient name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Birthday',
          align: 'left',
          sortable: false
        },
        {
          text: 'Match',
          align: 'left',
          sortable: false
        }
      ],
      changeClientRequestInProgress: false
    }
  },
  async mounted() {
    this.patientCasesProgress = true
    try {
      let patientCasesRaw = await api.getCasesWithSamePatient(this.editedCase.id)
      this.$set(this, 'patientCasesRaw', patientCasesRaw.data)
      this.patientCasesLoaded = true
    } catch (e) {
      console.error('Unable to get cases with same patient: ' + e.message)
    }

    this.patientCasesProgress = false
    this.changeClientId = this.editedCase.clientId
  },
  computed: {
    material_sampling() {
      if (this.editedCase.materialSampling) {
        const date = new Date(this.editedCase.materialSampling)
        return date.toISOString().replace('Z', '')
      }
      return null
    },
    correctButtonVisible() {
      return this.editedCase.estimatedCompletionDatetime
    },
    clientHasEmail() {
      return (this.clientEmails && this.clientEmails.length > 0) ||
             (this.clientSpecialistEmail && this.clientSpecialistEmail.length > 0)
    },
    clientEmails() {
      return _.get(this.clientsById, [this.editedCase.clientId, 'email'], null)
    },
    clientSpecialistEmail() {
      return _.get(this.clientSpecialist, 'email', null)
    },
    clientSpecialistName() {
      return _.get(this.clientSpecialist, 'name', null)
    },
    clientSpecialist() {
      let specialists = _.get(this.clientsById, [this.editedCase.clientId, 'specialists'], null)

      if (!specialists) {
        return null
      }

      let index = _.findIndex(specialists, (item) => {
        return item.id === this.editedCase.clientSpecialistId
      })

      return specialists[index]
    },
    clientSpecialists() {
      let specialists = _.get(this.clientsById, [this.editedCase.clientId, 'specialists'], null)

      if (!specialists) {
        return null
      }

      return _.filter(specialists, (item) => {
        return item.role === 'specialist' && item.email && item.email.length > 0
      })
    },
    clientAdministrators() {
      let specialists = _.get(this.clientsById, [this.editedCase.clientId, 'specialists'], null)

      if (!specialists) {
        return null
      }

      return _.filter(specialists, (item) => {
        return item.role === 'administrator' && item.email && item.email.length > 0
      })
    },
    clientTitle() {
      let clientTitle = _.get(this.clientsById, [this.editedCase.clientId, 'title'], null)

      return clientTitle
    },
    patientCases() {
      if (!this.patientCasesRaw) {
        return []
      }

      let samePatientNameAndBirthday = _.get(this.patientCasesRaw, 'samePatientNameAndBirthday', [])
      let samePatientName = _.get(this.patientCasesRaw, 'samePatientName', [])

      if (samePatientNameAndBirthday === null) {
        samePatientNameAndBirthday = []
      }

      if (samePatientName === null) {
        samePatientName = []
      }

      let patientCases = []

      let samePatientNameAndBirthdayCases = this.buildPatientCases(samePatientNameAndBirthday, 'Patient name + birthday')

      if (samePatientNameAndBirthdayCases.length > 0) {
        patientCases = _.concat(patientCases, samePatientNameAndBirthdayCases)
      }

      let samePatientNameCases = this.buildPatientCases(samePatientName, 'Patient name')

      if (samePatientNameCases.length > 0) {
        patientCases = _.concat(patientCases, samePatientNameCases)
      }

      return patientCases
    },
    holdHistoryVisible() {
      return this.editedCase.holdHistory && this.editedCase.holdHistory.length > 0
    },
    ecdcHistoryVisible() {
      return this.editedCase.ecdcHistory && this.editedCase.ecdcHistory.length > 0
    },
    holdButtonVisible() {
      let status = this.editedCase.status
      let inTerminalStatus = (status === 'validated' || status === 'archived')

      // Закомментировал, чтобы дать возможно`ть ставить на hold кейсы с просрочкой
      /* let estimatedCompletionDatetime = this.editedCase.estimatedCompletionDatetime

      let estimatedCompletionDatetimeOk = false

      if (estimatedCompletionDatetime) {
        let date = moment(estimatedCompletionDatetime, moment.ISO_8601)
        let now = moment()

        if (date.isAfter(now)) {
          estimatedCompletionDatetimeOk = true
        }
      } */

      return !this.editedCase.onHold && !inTerminalStatus // && estimatedCompletionDatetimeOk
    },
    availableSpecialists() {
      let clientId = _.get(this.editedCase, 'clientId', null)

      if (clientId == null) {
        return []
      }

      let client = _.get(this.clientsById, clientId, null)

      if (client == null) {
        return []
      }

      let specialists = _.get(client, 'specialists', [])

      return _.filter(specialists, (item) => {
        return item.role === 'specialist'
      })
    },
    canEditFields() {
      return this.editedCase.canEditFields
    },
    fetchDPUrl() {
      return this.$store.state.dpURL
    }
  },
  methods: {
    async caseMaterialSamplingFieldSaveHandler({value, context}) {
      let date, userTimezoneOffset, d, val
      try {
        date = new Date(value)
        userTimezoneOffset = date.getTimezoneOffset() * 60000
        d = new Date(date.getTime() - userTimezoneOffset)
        val = d.toISOString()
      } catch (e) {
        val = null
      }

      let errors = null
      if (value.length === 0) {
        value = null
      }

      try {
        let updatedCase = await api.updateCase({
          id: this.editedCase.id,
          materialSampling: val
        })
        this.$emit('caseFieldUpdated', {
          caseId: this.editedCase.id,
          fieldName: 'materialSampling',
          fieldValue: updatedCase['materialSampling']
        })
      } catch (e) {
        errors = ['Unable to save ' + 'materialSampling']

        if (e && e.code === 3) {
          errors = extractErrorToArray(e, 'Unable to save ' + 'materialSampling')
        }

        return errors
      }
    },
    emitCaseFieldUpdated(event) {
      this.$emit('caseFieldUpdated', event)
    },
    resolveCaseServicePageUrl() {
      let route = this.$router.resolve({name: 'CaseServicesPage', params: { caseId: this.editedCase.id }})
      return route.href
    },
    changeRequestSpecialist(item) {
      if (item.length === 0) {
        return
      }
      let specialists = this.clientSpecialists

      let anySpecInRequest = false
      for (let s of specialists) {
        if (this.createRequestSelectedEmails.indexOf(s.email) > -1) {
          anySpecInRequest = true
        }
      }

      if (!anySpecInRequest) {
        return
      }

      let specEmail = this.clientSpecialistEmail
      if (item[0] !== specEmail &&
          this.createRequestSelectedEmails.indexOf(specEmail) === -1) {
        if (!specEmail) {
          return
        }
        this.createRequestSelectedEmails.push(specEmail)
      }
    },
    getItemDataByPath(item, path) {
      return _.get(item, path, '-')
    },
    handleHoldClick() {
      this.holdConfirmationWindowVisible = true
    },
    handleHoldCancelButtonClick() {
      this.holdConfirmationWindowVisible = false
      this.holdReason = null
    },
    handleCreateRequestClick() {
      this.createRequestConfirmationWindowVisible = true
    },
    async handleRemoveHoldClick() {
      this.unholdInProgress = true

      try {
        let updatedCase = await api.unholdCase(this.editedCase.id)
        this.$emit('caseFieldUpdated', {
          caseId: updatedCase.id,
          fieldName: 'holdHistory',
          fieldValue: updatedCase.holdHistory
        })

        this.$emit('caseFieldUpdated', {
          caseId: updatedCase.id,
          fieldName: 'onHold',
          fieldValue: updatedCase.onHold
        })

        this.$emit('caseFieldUpdated', {
          caseId: updatedCase.id,
          fieldName: 'estimatedCompletionDatetime',
          fieldValue: updatedCase.estimatedCompletionDatetime
        })
      } catch (e) {
        showApiError(this, e, 'Unable to remove case hold')
      }

      this.unholdInProgress = false
    },
    handleCancelButtonClick() {
      this.$emit('close')
    },
    handleRemoveServiceFromCase(result) {
      this.$emit('removedServiceFromCase', result)
    },
    handleAddServiceFromCase(addedItem) {
      this.$emit('addedServiceToCase', addedItem)
    },
    handleUpdateCaseService(updatedItem) {
      this.$emit('updatedCaseService', updatedItem)
    },
    handleUpdateCasePrice(updatedItem) {
      this.$emit('caseFieldUpdated', {
        caseId: updatedItem.caseId,
        fieldName: 'price',
        fieldValue: updatedItem.price
      })
    },
    async caseSimpleFieldSaveHandler({value, context}) {
      let errors = null
      if (value.length === 0) {
        value = null
      }

      try {
        let updatedCase = await api.updateCase({
          id: this.editedCase.id,
          [context]: value
        })
        this.$emit('caseFieldUpdated', {
          caseId: this.editedCase.id,
          fieldName: context,
          fieldValue: updatedCase[context]
        })
      } catch (e) {
        errors = ['Unable to save ' + context]

        if (e && e.code === 3) {
          errors = extractErrorToArray(e, 'Unable to save ' + context)
        }

        return errors
      }
    },
    async caseSimpleNumberFieldSaveHandler({value, context}) {
      let errors = null
      if (value.length === 0) {
        value = null
      }
      if (isNumeric(value)) {
        value = parseFloat(value)
      }

      if (_.isString(value) && value.length === 0) {
        value = null
      }
      try {
        let updatedCase = await api.updateCase({
          id: this.editedCase.id,
          [context]: value
        })
        this.$emit('caseFieldUpdated', {
          caseId: this.editedCase.id,
          fieldName: context,
          fieldValue: updatedCase[context]
        })
      } catch (e) {
        errors = ['Unable to save ' + context]

        if (e && e.code === 3) {
          errors = extractErrorToArray(e, 'Unable to save ' + context)
        }

        return errors
      }
    },

    async caseSimpleOMIFieldSaveHandler({value, context}) {
      if (value.length !== 0 && value.length !== 16) {
        return 'The length of the medical insurance should be no more than 16 characters'
      }
      return await this.caseSimpleFieldSaveHandler({value, context})
    },
    snilsValidate(snils) {
      var result = false
      let error = {}
      if (typeof snils === 'number') {
        snils = snils.toString()
      } else if (typeof snils !== 'string') {
        snils = ''
      }
      if (!snils.length) {
        error.code = 1
        error.message = 'СНИЛС пуст'
      } else if (/[^0-9]/.test(snils)) {
        error.code = 2
        error.message = 'СНИЛС может состоять только из цифр'
      } else if (snils.length !== 11) {
        error.code = 3
        error.message = 'СНИЛС может состоять только из 11 цифр'
      } else {
        var sum = 0
        for (var i = 0; i < 9; i++) {
          sum += parseInt(snils[i]) * (9 - i)
        }
        var checkDigit = 0
        if (sum < 100) {
          checkDigit = sum
        } else if (sum > 101) {
          checkDigit = parseInt(sum % 101)
          if (checkDigit === 100) {
            checkDigit = 0
          }
        }
        if (checkDigit === parseInt(snils.slice(-2))) {
          result = true
        } else {
          error.code = 4
          error.message = 'Неправильное контрольное число'
        }
      }
      return result
    },
    async caseSimpleSnilsFieldSaveHandler({value, context}) {
      if (value !== '' && !this.snilsValidate(value)) {
        return 'snils is not valid'
      }
      return await this.caseSimpleFieldSaveHandler({value, context})
    },

    async paidAmountSaveHandler({value}) {
      let errors = null

      if (isNumeric(value)) {
        value = parseFloat(value)
      }

      if (_.isString(value) && value.length === 0) {
        value = null
      }

      try {
        let updatedCase = await api.updateCase({
          id: this.editedCase.id,
          paymentAmount: value,
          paymentCurrency: 'rub'
        })
        this.$emit('caseFieldUpdated', {
          caseId: this.editedCase.id,
          fieldName: 'paymentAmount',
          fieldValue: updatedCase.paymentAmount
        })
      } catch (e) {
        errors = ['Unable to save amount']

        if (e && e.code === 3) {
          errors = extractErrorToArray(e, 'Unable to save amount')
        }

        return errors
      }
    },
    async commentSaveHandler({value}) {
      let errors = null

      if (value.length === 0) {
        value = null
      }

      try {
        let updatedCase = await api.updateCase({
          id: this.editedCase.id,
          comment: value
        })
        this.$emit('caseFieldUpdated', {
          caseId: this.editedCase.id,
          fieldName: 'comment',
          fieldValue: updatedCase.comment
        })
      } catch (e) {
        errors = ['Unable to save comment']

        if (e && e.code === 3) {
          errors = extractErrorToArray(e, 'Unable to save comment')
        }

        return errors
      }
    },
    handleCaseUpdated(newCase) {
      this.$emit('caseUpdated', newCase)
    },
    async handleCaseSpecialistChange(newValue) {
      let errors = null

      try {
        let updatedCase = await api.updateCase({
          id: this.editedCase.id,
          clientSpecialistId: newValue || null
        })
        this.$emit('caseFieldUpdated', {
          caseId: this.editedCase.id,
          fieldName: 'clientSpecialistId',
          fieldValue: updatedCase.clientSpecialistId
        })
      } catch (e) {
        errors = ['Unable to update client specialist']

        if (e && e.code === 3) {
          errors = extractErrorToArray(e, 'Unable to update client specialist')
        }

        return errors
      }
    },
    async handleCaseAreaChange(newValue) {
      let errors = null

      try {
        let updatedCase = await api.updateCase({
          id: this.editedCase.id,
          registrationPlace: newValue || null
        })
        this.$emit('caseFieldUpdated', {
          caseId: this.editedCase.id,
          fieldName: 'registrationPlace',
          fieldValue: updatedCase.registrationPlace
        })
      } catch (e) {
        errors = ['Unable to update client specialist']

        if (e && e.code === 3) {
          errors = extractErrorToArray(e, 'Unable to update client specialist')
        }

        return errors
      }
    },
    async handleHoldButtonClick() {
      if (!this.$refs['holdReasonInput'].validate(true)) {
        return false
      }

      this.holdInProgress = true

      try {
        let updatedCase = await api.holdCase(this.editedCase.id, this.holdReason)
        this.$emit('caseFieldUpdated', {
          caseId: updatedCase.id,
          fieldName: 'holdHistory',
          fieldValue: updatedCase.holdHistory
        })

        this.$emit('caseFieldUpdated', {
          caseId: updatedCase.id,
          fieldName: 'onHold',
          fieldValue: updatedCase.onHold
        })

        this.$emit('caseFieldUpdated', {
          caseId: updatedCase.id,
          fieldName: 'estimatedCompletionDatetime',
          fieldValue: updatedCase.estimatedCompletionDatetime
        })
      } catch (e) {
        showApiError(this, e, 'Unable to hold case')
      }

      this.holdInProgress = false
      this.holdConfirmationWindowVisible = false
      this.holdReason = null
    },
    resetCreatedRequest() {
      this.createRequestConfirmationWindowVisible = false
      this.createRequestSelectedEmails = []
      this.createRequestReason = ''
      this.createRequestTemplate = ''
    },
    async sendCreatedRequest() {
      // убираем дубли чтобы небыло лишних отправок
      let tmpEmails = this.createRequestSelectedEmails.join(',').split(',')
      tmpEmails = _.map(tmpEmails, o => o.trim())
      tmpEmails = _.uniqBy(tmpEmails, o => o)

      let data = {
        caseId: this.editedCase.id,
        emails: tmpEmails.join(','),
        reasonText: this.createRequestReason,
        template: this.createRequestTemplate
      }

      try {
        await api.caseRequestClinicalData(data)
        this.resetCreatedRequest()
      } catch (e) {
        showApiError(this, e, 'Unable to send request')
      }
    },
    async handleUpdateCaseInDpButtonClick() {
      this.updateCaseInDPInProgress = true

      try {
        await api.updateCaseInDP(this.editedCase.id)

        this.$snotify.success('Task for update case in DP was successfully sent')
      } catch (e) {
        showApiError(this, e, 'Unable to update case in dp')
      }

      this.updateCaseInDPInProgress = false
    },
    buildPatientCases(cases, match) {
      let result = []
      for (let item of cases) {
        let patientCase = {
          id: item.id,
          dpCaseLink: null,
          patientName: item.patientName,
          birthday: item.patientBirthday,
          match: match,
          title: item.title,
          creationDatetime: item.creationDatetime,
          patientNameFuzzy: false,
          patientBirthdayFuzzy: false
        }

        let clientTitle = _.get(this.clientsById, [item.clientId, 'title'], '-')

        patientCase.clientTitle = clientTitle

        if (this.editedCase.patientName !== item.patientName) {
          patientCase.patientNameFuzzy = true
        }

        if (this.editedCase.patientBirthday !== item.patientBirthday) {
          patientCase.patientBirthdayFuzzy = true
        }

        if (item.dpId) {
          patientCase.dpCaseLink = this.buildDPCaseUrl(item.dpId)
        }

        result.push(patientCase)
      }

      return result
    },
    buildDPCaseUrl(dpCaseId) {
      return `${this.fetchDPUrl}cases/${dpCaseId}`
    },
    handleRequestedQuantityChanged(event) {
      this.$emit('requestedQuantityChanged', event)
    },
    handleExecutedQuantityChanged(event) {
      this.$emit('executedQuantityChanged', event)
    }
  }
}
</script>

<style>
  .case-param-name {
    min-width: 320px;
  }

  .fuzzyValue {
    color: rgba(255, 160, 0, 1);
  }

  .title-request{
    text-align: center;
    padding: 0;
    margin: 0;
    font-size: 14pt;
    margin-bottom: -15px;
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sales/CaseDetails.vue